export default {"src":"/_next/static/media/poln_logo_teal.412e477c.svg","height":98,"width":439,"blurWidth":0,"blurHeight":0};